import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { cn } from "@/lib/utils";

let cache = null;
const listeners = new Set();
export const refreshBranding = async () => {
  try { const r = await fetch(`${API}/branding`); cache = await r.json(); } catch { cache = { has_logo: false }; }
  listeners.forEach((fn) => fn(cache));
  return cache;
};
export const useBranding = () => {
  const [b, setB] = useState(cache);
  useEffect(() => { listeners.add(setB); if (!cache) refreshBranding(); return () => listeners.delete(setB); }, []);
  return b || { has_logo: false };
};

export const BrandMark = ({ className, textClass = "text-lg", testId = "brand-mark" }) => {
  const b = useBranding();
  if (b.has_logo) return <img data-testid={testId} src={`${API}/branding/logo?v=${encodeURIComponent(b.version || "")}`} alt="Logo Yutaka" className={cn("shrink-0 rounded-lg object-contain bg-white", className)} />;
  return <div data-testid={testId} className={cn("shrink-0 rounded-lg bg-primary text-primary-foreground grid place-items-center font-heading font-bold", textClass, className)}>Y</div>;
};
